import React from 'react';
import './GanttChartView.scss';
import { MarketplaceTemplatePreviewComponent } from '../../../AdminMarketplace/MarketplaceTemplatePreview/MarketplaceTemplatePreview.component';
import { GanttChartItem } from '../../../GanttChartComponent/models/GanttChartItem.model';
import { TimelineEvent } from '../../../../slices/marketplace/timeline/models/timeline-event.model';
import { EngagementBuyerActionState } from '../../../../slices/marketplace/timeline/models/engagement-buyer-action-state.model';
import { TimelineClosingDate } from '../../../../slices/marketplace/closing-date/models/timeline-closing-date.model';

interface MyEngagementProps {
    timelineEvents: TimelineEvent[];
    buyerActionState?: EngagementBuyerActionState[];
    startDate: Date;
    onEventClick(item: GanttChartItem): void;
    isEventClickable?: (eventId: string) => boolean;
    currentDate?: Date;
    closingDate?: TimelineClosingDate | null;
}

const GanttChartView = (props: MyEngagementProps) => {
    return (
        <div className="gantt-chart-view gantt-chart-container">
            <MarketplaceTemplatePreviewComponent
                events={props.timelineEvents}
                buyerActionState={props.buyerActionState}
                startDate={props.startDate}
                displayCurrentDayIndicator={true}
                onEventClick={props.onEventClick}
                isEventClickable={props.isEventClickable}
                currentDate={props.currentDate}
                closingDate={props.closingDate}
            />
        </div>
    );
};

export default GanttChartView;
